import { useState } from 'react';
import { useAuthStore } from 'src/store/auth';

const MobileHeader = () => {
  const { user, logout } = useAuthStore();
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);

  return (
    <div className="lg:hidden fixed top-0 left-0 right-0 z-50 bg-primary px-7 pt-2.5 pb-4 flex items-center justify-between">
        <img src="/icons/onehealth-logo.svg" alt="onehealth" className="h-4.5 w-28" />

      <div className="relative">
        <button
          type="button"
          className="flex items-center space-x-2"
          onClick={() => setIsProfileMenuOpen((v) => !v)}
        >
          <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
            <span className="text-white text-sm font-medium">
              {(user?.firstName?.[0] || 'J').toUpperCase()}{(user?.lastName?.[0] || 'D').toUpperCase()}
            </span>
          </div>
        </button>

        {isProfileMenuOpen && (
          <div className="absolute right-0 top-full mt-2 bg-white text-black rounded-md shadow-lg min-w-[140px] z-50">
            <div className="px-4 py-2 border-b border-gray-200">
              <p className="text-sm font-medium">{user ? `${user.firstName} ${user.lastName}` : 'John Doe'}</p>
              <p className="text-xs text-gray-500">{user?.email || 'johndoe@gmail.com'}</p>
            </div>
            <button
              className="w-full text-left px-4 py-2 hover:bg-gray-50 rounded-md text-sm"
              onClick={() => {
                setIsProfileMenuOpen(false);
                logout();
              }}
            >
              Logout
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default MobileHeader;